var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommerzbank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 602.36218,
    height: 109.94881,
    id: "svg3681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs3683"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    cx: 0,
    cy: 0,
    r: 1,
    fx: 0,
    fy: 0,
    id: "radialGradient263",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(24.979874,0,0,-24.979874,568.24237,786.90625)",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop265",
    style: {
      stopColor: "#fedf33",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop267",
    style: {
      stopColor: "#fbb809",
      stopOpacity: 1
    },
    offset: 0.44000199
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop269",
    style: {
      stopColor: "#ee960d",
      stopOpacity: 1
    },
    offset: 0.89999402
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop271",
    style: {
      stopColor: "#d87301",
      stopOpacity: 1
    },
    offset: 1
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    cx: 0,
    cy: 0,
    r: 1,
    fx: 0,
    fy: 0,
    id: "radialGradient3640",
    xlinkHref: "#radialGradient263",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(24.979874,0,0,-24.979874,568.24237,786.90625)",
    spreadMethod: "pad"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 0,
    cy: 0,
    r: 1,
    fx: 0,
    fy: 0,
    id: "radialGradient239",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(24.910126,0,0,-24.910126,543.59962,793.65115)",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop241",
    style: {
      stopColor: "#fedf33",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop243",
    style: {
      stopColor: "#fbb809",
      stopOpacity: 1
    },
    offset: 0.44000199
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop245",
    style: {
      stopColor: "#ee960d",
      stopOpacity: 1
    },
    offset: 0.89999402
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop247",
    style: {
      stopColor: "#e17a10",
      stopOpacity: 1
    },
    offset: 1
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    cx: 0,
    cy: 0,
    r: 1,
    fx: 0,
    fy: 0,
    id: "radialGradient3643",
    xlinkHref: "#radialGradient239",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(24.910126,0,0,-24.910126,543.59962,793.65115)",
    spreadMethod: "pad"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 0,
    cy: 0,
    r: 1,
    fx: 0,
    fy: 0,
    id: "radialGradient215",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(24.920029,0,0,-24.920029,561.75633,811.72659)",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop217",
    style: {
      stopColor: "#fedf33",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop219",
    style: {
      stopColor: "#fbb809",
      stopOpacity: 1
    },
    offset: 0.44000199
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop221",
    style: {
      stopColor: "#ee960d",
      stopOpacity: 1
    },
    offset: 0.89999402
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop223",
    style: {
      stopColor: "#e17a10",
      stopOpacity: 1
    },
    offset: 1
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    cx: 0,
    cy: 0,
    r: 1,
    fx: 0,
    fy: 0,
    id: "radialGradient3646",
    xlinkHref: "#radialGradient215",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(24.920029,0,0,-24.920029,561.75633,811.72659)",
    spreadMethod: "pad"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 0,
    cy: 0,
    r: 1,
    fx: 0,
    fy: 0,
    id: "radialGradient191",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(24.901733,0,0,-24.901718,568.25887,786.98686)",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop193",
    style: {
      stopColor: "#fedf33",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop195",
    style: {
      stopColor: "#fbb809",
      stopOpacity: 1
    },
    offset: 0.44000199
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop197",
    style: {
      stopColor: "#ee960d",
      stopOpacity: 1
    },
    offset: 0.89999402
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop199",
    style: {
      stopColor: "#e17a10",
      stopOpacity: 1
    },
    offset: 1
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    cx: 0,
    cy: 0,
    r: 1,
    fx: 0,
    fy: 0,
    id: "radialGradient3649",
    xlinkHref: "#radialGradient191",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(24.901733,0,0,-24.901718,568.25887,786.98686)",
    spreadMethod: "pad"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-544.27348,-995.30113)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.6667598,0,0,-2.6667598,-401.84366,3177.6898)",
    id: "g3651"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 562.198,811.726 C 561.613,811.726 559.874,811.726 557.853,809.272 L 557.853,809.272 C 557.879,809.241 557.905,809.21 557.932,809.178 L 557.932,809.178 C 558.451,809.785 559.102,810.406 559.801,810.858 L 559.801,810.858 C 560.447,811.274 561.196,811.552 561.816,811.62 L 561.816,811.62 C 562.268,811.67 563.763,811.651 565.465,811.651 L 565.465,811.651 C 565.474,811.651 565.479,811.647 565.483,811.642 L 565.483,811.642 L 565.439,811.716 C 565.436,811.723 565.43,811.726 565.423,811.726 L 565.423,811.726 L 562.198,811.726 z",
    id: "path201",
    style: {
      fill: "url(#radialGradient3649)",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 550.345,811.726 C 550.339,811.726 550.332,811.724 550.328,811.717 L 550.328,811.717 L 543.998,800.753 L 542.013,797.315 L 541.783,796.916 L 541.753,796.865 C 541.751,796.861 541.751,796.854 541.755,796.846 L 541.755,796.846 L 547.785,786.402 L 547.785,786.445 C 547.654,786.685 547.56,786.87 547.51,786.986 L 547.51,786.986 C 547.258,787.557 547.115,788.347 547.152,789.115 L 547.152,789.115 C 547.254,791.137 548.329,793.132 548.87,794.068 L 548.87,794.068 C 550.138,796.264 552.589,800.511 552.589,800.511 L 552.589,800.511 C 552.589,800.511 555.041,804.758 556.309,806.955 L 556.309,806.955 C 556.849,807.89 558.04,809.819 559.741,810.918 L 559.741,810.918 C 560.386,811.335 561.144,811.605 561.762,811.673 L 561.762,811.673 C 562.215,811.724 563.719,811.726 565.423,811.726 L 565.423,811.726 L 550.345,811.726 z",
    id: "path225",
    style: {
      fill: "url(#radialGradient3646)",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 541.805,796.763 C 541.9,796.597 541.994,796.433 542.087,796.273 L 542.087,796.273 L 541.805,796.763 z M 572.137,793.703 C 571.768,793.201 571.156,792.68 570.472,792.33 L 570.472,792.33 C 568.669,791.407 566.405,791.34 565.325,791.34 L 565.325,791.34 L 557.884,791.34 L 550.444,791.34 C 549.364,791.34 547.097,791.407 545.297,792.33 L 545.297,792.33 C 544.612,792.68 544,793.201 543.631,793.703 L 543.631,793.703 C 543.397,794.022 542.797,795.044 542.087,796.273 L 542.087,796.273 L 543.6,793.651 L 549.294,783.788 C 549.297,783.783 549.304,783.779 549.31,783.779 L 549.31,783.779 L 566.459,783.779 C 566.464,783.779 566.471,783.784 566.474,783.789 L 566.474,783.789 L 573.946,796.73 C 573.122,795.303 572.4,794.06 572.137,793.703",
    id: "path249",
    style: {
      fill: "url(#radialGradient3643)",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 561.762,811.673 C 561.144,811.605 560.386,811.335 559.741,810.918 L 559.741,810.918 C 559.029,810.458 558.407,809.853 557.884,809.236 L 557.884,809.236 C 558.611,808.379 559.145,807.5 559.459,806.955 L 559.459,806.955 C 560.727,804.758 563.18,800.511 563.18,800.511 L 563.18,800.511 C 563.18,800.511 565.631,796.264 566.9,794.068 L 566.9,794.068 C 567.439,793.132 568.515,791.137 568.615,789.115 L 568.615,789.115 C 568.653,788.347 568.508,787.557 568.259,786.986 L 568.259,786.986 C 568.084,786.587 567.389,785.374 566.582,783.976 L 566.582,783.976 L 574.015,796.849 C 574.015,796.85 574.016,796.851 574.016,796.853 L 574.016,796.853 L 574.016,796.861 C 574.016,796.863 574.015,796.865 574.014,796.866 L 574.014,796.866 L 565.439,811.716 C 565.436,811.723 565.43,811.726 565.423,811.726 L 565.423,811.726 C 563.719,811.726 562.215,811.724 561.762,811.673",
    id: "path273",
    style: {
      fill: "url(#radialGradient3640)",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 461.3125,47.21875 C 456.01,47.21875 451.78125,51.58375 451.78125,57.0625 C 451.78126,62.788751 455.9375,66.75 461.0625,66.75 C 463.99625,66.749999 466.26875,65.69875 468,63.71875 L 465.4375,61.09375 C 464.37749,62.225002 463.04375,62.84375 461.3125,62.84375 C 458.30875,62.84375 456.28125,60.3275 456.28125,56.96875 C 456.28124,53.717501 458.3525,51.125 461.25,51.125 C 462.77126,51.125001 464.06375,51.69375 465.125,52.71875 L 467.78125,49.96875 C 466.225,48.2725 463.92875,47.21875 461.3125,47.21875 z M 479.28125,47.21875 C 473.66125,47.21875 469.4375,51.61875 469.4375,57.0625 C 469.43751,62.577501 473.43,66.75 479.15625,66.75 C 484.77626,66.749999 489,62.35125 489,56.90625 C 489,51.392499 485.00625,47.21875 479.28125,47.21875 z M 493.5625,47.53125 L 491.71875,66.40625 L 495.625,66.40625 L 496.5,56.21875 C 496.67625,54.238748 496.6875,52.1875 496.6875,52.1875 L 496.78125,52.1875 C 496.78125,52.187501 497.21625,54.25125 497.78125,56.125 L 500.96875,66.40625 L 504.6875,66.40625 L 507.875,56.03125 C 508.44,54.22875 508.875,52.1875 508.875,52.1875 L 508.9375,52.1875 C 508.9375,52.187501 508.98,54.23 509.15625,56.28125 L 510,66.40625 L 514.15625,66.40625 L 512.3125,47.53125 L 506.84375,47.53125 L 503.96875,56.875 C 503.51001,58.3975 503.03125,60.34375 503.03125,60.34375 C 503.03124,60.34375 502.5275,58.4 502.03125,56.84375 L 499.125,47.53125 L 493.5625,47.53125 z M 519.875,47.53125 L 518.0625,66.40625 L 521.96875,66.40625 L 522.8125,56.21875 C 522.98876,54.238748 523.03125,52.1875 523.03125,52.1875 L 523.09375,52.1875 C 523.09373,52.187501 523.56,54.25125 524.125,56.125 L 527.3125,66.40625 L 531.03125,66.40625 L 534.1875,56.03125 C 534.75373,54.22875 535.1875,52.1875 535.1875,52.1875 L 535.25,52.1875 C 535.24998,52.187501 535.2925,54.23 535.46875,56.28125 L 536.3125,66.40625 L 540.5,66.40625 L 538.65625,47.53125 L 533.1875,47.53125 L 530.3125,56.875 C 529.85249,58.3975 529.375,60.34375 529.375,60.34375 C 529.37501,60.34375 528.87,58.4 528.375,56.84375 L 525.46875,47.53125 L 519.875,47.53125 z M 545,47.53125 L 545,66.40625 L 557.28125,66.40625 L 557.28125,62.78125 L 549.125,62.78125 L 549.125,58.65625 L 556.03125,58.65625 L 556.03125,55.125 L 549.125,55.125 L 549.125,51.125 L 557.15625,51.125 L 557.15625,47.53125 L 545,47.53125 z M 562.125,47.53125 L 562.125,66.40625 L 566.25,66.40625 L 566.25,59.53125 L 567.53125,59.53125 L 571.5625,66.40625 L 576.46875,66.40625 L 571.8125,58.8125 C 574.25126,57.89375 575.625,56.00125 575.625,53.5625 C 575.62497,49.745001 573.4725,47.53125 567.78125,47.53125 L 562.125,47.53125 z M 579.0625,47.53125 L 579.0625,51.125 L 586.6875,51.125 L 578.875,63.28125 L 578.875,66.40625 L 592.03125,66.40625 L 592.03125,62.78125 L 584.03125,62.78125 L 591.84375,50.625 L 591.84375,47.53125 L 579.0625,47.53125 z M 596.28125,47.53125 L 596.28125,66.40625 L 603.5,66.40625 C 606.85877,66.406248 610.59375,64.89125 610.59375,60.96875 C 610.59373,58.529999 609.03625,56.87875 606.5625,56.5625 L 606.5625,56.53125 C 608.50623,55.92875 609.71875,54.46 609.71875,52.375 C 609.71874,48.273749 606.1025,47.53125 602.8125,47.53125 L 596.28125,47.53125 z M 618.6875,47.53125 L 611.96875,66.40625 L 616.09375,66.40625 L 617.40625,62.5625 L 624.75,62.5625 L 626.0625,66.40625 L 630.5,66.40625 L 623.78125,47.53125 L 618.6875,47.53125 z M 633.0625,47.53125 L 633.0625,66.40625 L 636.875,66.40625 L 636.875,57.4375 C 636.875,55.739999 636.75,54 636.75,54 C 636.74998,54.000002 637.63625,55.51625 638.625,57 L 645.03125,66.40625 L 648.6875,66.40625 L 648.6875,47.53125 L 644.84375,47.53125 L 644.84375,56.09375 C 644.84376,57.791249 644.96875,59.5 644.96875,59.5 C 644.96875,59.5 644.085,57.985 643.09375,56.5 L 636.96875,47.53125 L 633.0625,47.53125 z M 653.21875,47.53125 L 653.21875,66.40625 L 657.3125,66.40625 L 657.3125,57.5625 L 663.34375,66.40625 L 668.40625,66.40625 L 661.46875,56.28125 L 667.75,47.53125 L 663,47.53125 L 657.3125,56 L 657.3125,47.53125 L 653.21875,47.53125 z M 479.21875,51.0625 C 482.47,51.062502 484.5625,53.6425 484.5625,57 C 484.56251,60.181252 482.54,62.90625 479.21875,62.90625 C 475.96625,62.90625 473.875,60.3275 473.875,56.96875 C 473.875,53.787501 475.89625,51.0625 479.21875,51.0625 z M 566.25,51.0625 L 567.9375,51.0625 C 570.12874,51.062499 571.40625,51.725 571.40625,53.5625 C 571.40627,55.330001 570.235,56.09375 567.9375,56.09375 L 566.25,56.09375 L 566.25,51.0625 z M 600.375,51.0625 L 602.75,51.0625 C 604.05748,51.062499 605.375,51.475 605.375,53.03125 C 605.37499,54.55 604.2475,55.15625 602.9375,55.15625 L 600.375,55.15625 L 600.375,51.0625 z M 621.09375,51.34375 C 621.09374,51.343751 621.445,52.62125 621.90625,54 L 623.5625,59 L 618.625,59 L 620.28125,54.03125 C 620.74127,52.617498 621.09375,51.34375 621.09375,51.34375 z M 600.375,58.625 L 603.40625,58.625 C 605.2425,58.625001 606.4375,59.2025 606.4375,60.6875 C 606.43749,62.137501 605.49125,62.875 603.40625,62.875 L 600.375,62.875 L 600.375,58.625 z",
    transform: "matrix(0.8,0,0,-0.8,0,841.89)",
    id: "path177",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommerzbank);
export default __webpack_public_path__ + "static/media/commerzbank.76a490023847c62315ef2d1bacf228a9.svg";
export { ForwardRef as ReactComponent };